import React from 'react'

const CategoryFeature = ({ category, onClick, hasNoParent, active, showCount = true }) => {
    return (
        <div style={{ fontSize: '16px' }} className={`row mx-1 `} onClick={onClick}>
            <div className={`col CategoriesFeatures-feature ${(active) ? "category-feature-active-category" : ""}`} >{hasNoParent ? 'Wszystkie kategorie' : category.catDescription}
                <span className='light-text-color ms-1'>{showCount && `(${category.artCount})`}</span>
            </div>
        </div>
    )
}

export default CategoryFeature